import { DateTime } from 'aos-helpers/src/helpers/Time'

import { TaskType } from '../TaskType'
import { BaseTask } from './BaseTask'

export interface SimpleTask extends BaseTask {
    type: TaskType.Simple
}
export interface Contractor {
    id: number
    name: string
    contractTime: DateTime
    jobStart: DateTime
    jobEnd: DateTime
    numberOfWorkers: number
}

export const simpleTaskContractorLabel = (contractor: Contractor) =>
    `${contractor.name}(${contractor.numberOfWorkers})`
